module.exports = __webpack_public_path__ + "img/4.5c2607e4.jpg";